export default function printClientDiagnostics(response) {
  const raw = response && response.headers && response.headers['x-client-diagnostics'];
  if (typeof raw !== 'string') return;
  try {
    const messages = JSON.parse(raw);
    if (!Array.isArray(messages)) return;
    messages.forEach((message) => {
      if (typeof message === 'string' && message.length <= 100) console.info(message);
    });
  } catch (error) {
    // Ignore invalid diagnostic metadata without interrupting API responses.
  }
}
